import { render, staticRenderFns } from "./SuccessFactors.vue?vue&type=template&id=6825daae&"
import script from "./SuccessFactors.vue?vue&type=script&lang=js&"
export * from "./SuccessFactors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports